const POE_DATA = [
  {
    id: 1,
    actName: "ACT 1",
    act: [
      "Twilight Strand - Kill Hillock - Go to Town",
      "Town - Talk to NPCs - Go to Coast",
      "Coast - Tag WP - Go to Tidal Island",
      "Tidal Island - Kill Hailrake (for Quicksilver Flask Reward) - TP to town",
      "Town - Claim Quicksilver - WP to Coast",
      "Coast - Go to Mud Flats",
      "Mud Flats - Get Glyphes - Go to Fetid Pool",
      "Fetid Pool - Clear Fetid Pool for Book of Regrets Reward - Go to Mud Flats",
      "Mud Flats - Go to Submerged Passage",
      "Submerged Passage - Place Portal on Bridge - Go to Ledge",
      "Ledge - Tag WP - Go to Town",
      "Town - Take Portal to Submerged Passage Bridge",
      "Sumbmereged Passage - Go to Flooded Depths",
      "Flooded Depths - Kill Deep Dweller - TP to town",
      "Town - Talk to NPCs - WP to Ledge",
      "Ledge - Go to Climb",
      "Climb - Kill Faun for Navali - Go to Lower Prison",
      "Lower Prison - Complete Trial - Go to Upper Prison",
      "Upper Prison - Go to Warden's Quarters",
      "Warden's Quarters - Follow Blood to Warden's Chambers",
      "Warden's Chambers - Kill Brutus - Go to Prisoner's Gate",
      "Prisoner's Gate - Tag WP - Go to Town",
      "Town - Talk to NPCs - WP to Prisoner's Gate",
      "Prisoner's Gate - Go to Ship Graveyard",
      "Ship Graveyard - Tag WP - Find next Zone",
      "Ship Graveyard Cave - Pick up Allflame - Exit Cave - Continue to Cavern of Warth",
      "- Tag WP - WP to Ship Graveyard",
      "Cavern of Warth - Tag WP - Go back to Ship Graveyard - Find Ship Graveyard",
      "Cave - Pick up Allflame - TP to Town - WP to Ship Graveyard",
      "Ship Graveyard - Kill Fairgraves - TP to Town",
      "Town - Talk to NPCs - WP to Cavern of Wrath",
      "Cavern of Wrath - Go to Cavern of Anger",
      "Cavern of Anger - Go to Merveil's Lair",
      "Merveil's Lair - Kill Merveil - Go to Act II",
    ],
  },
  {
    id: 2,
    actName: "ACT 2",
    act: [
      "Southern Forest - Go to Town",
      "Town - Go to Old Fields",
      "Old Fields - (Enter the Den and kill the Great White Beast for Quicksilver Reward and",
      "follow-up Quest which gives Book of Regrets) - Go to Crossroads",
      "Crossroads - Tag WP - Go up/left to Chamber of Sins",
      "Chamber of Sins Level 1 - Go to Chamber of Sins Level 2",
      "Chamber of Sins Level 2 - Complete Trail - Kill Fidelitas - TP to Town",
      "Town - Talk to NPCs (for Heralds) - WP to Crossroards",
      "Crossroads - Go up/right to Broken Bridge",
      "Broken Bridge - Kill Kraityn - TP to town",
      "Town - WP to Crossroads",
      "Crossroads - Go to Fellshrine Ruins (right/down)",
      "Fellshrine Ruins - Go to Crypt Level 1",
      "Crypt Level 1 - Solve Trial - Go to Crypt Level 2",
      "Crypt Level 2 - Find Golden Hand (for Book of Regrets Reward) - TP to Town",
      "Town - Go to Riverways",
      "Riverways - Tag WP - Go to Western Forest",
      "Western Forest - Tag WP - Kill Alira (same side as WP, broken side of road) - Kill Arteri",
      "(end of road) - Open Thaumetic Seal - Go to Weaver's Chamber (other side than Alira)",
      "Weaver's Chamber - Go to Weaver's Nest",
      "Weaver's Nest - Kill Weaver - TP to Town",
      "Town - Talk to NPCs - WP to Act I town",
      "Lioneye's Watch - Talk to Bestel for Reward - WP to Riverways",
      "Riverways - Go to Wetlands (up)",
      "Wetlands - Kill Oak (middle) - Remove Roots - TP to Town",
      "Town - Talk to Eremir - TP to Wetlands",
      "Wetlands - Go to Vaal Ruins",
      "Vaal Ruins - Go to Northern Forest",
      "Northern Forest - Go to Caverns",
      "Caverns - Go to Ancient Pyramid",
      "Ancient Pyramid - Go to Pyramid Apex",
      "Pyramid Apex - Kill Vaal Oversoul - Go to Act III",
    ],
  },
  {
    id: 3,
    actName: "ACT 3",
    act: [
      "City of Sarn - Kill Guard Captain - Talk to Clarissa - Go to Town",
      "Town - Go to Slums",
      "Slums - Go to Crematorium",
      "Crematorium - Solve Trial - Kill Piety - Get Bracelet - TP to Town",
      "Town - Get Keys from Clarissa - Go to Slums",
      "Slums - Go to Sewers",
      "Sewers - Take Bust - Tag WP - Take 2 remaining Busts - Go to Marketplace",
      "Marketplace - Tag WP - Go to Catacombs (near WP)",
      "Catacombs - Solve Trial - TP to Town",
      "Town - Talk to NPCs - WP to Marketplace",
      "Marketplace - Go to Battlefront (up/left)",
      "Battlefront - Tag WP - Kill Aurelianus - Take Ribbon Spool - Go to Docks (left)",
      "Docks - Take Thaumatic Sulphite - TP to Town",
      "Town - Talk to NPCs - WP to Battlefront",
      "Battlefront - Go to Solaris Temple (up)",
      "Solaris Temple Level 1 - Go to Solaris Temple Level 2",
      "Solaris Temple Level 2 - Talk to Dialla - WP to Sewers",
      "Sewers - Open Undying Blockage - Go to Ebony Barracks",
      "Ebony Barracks - Tag WP - Kill General Gravicius - Go to Lunaris Temple",
      "Lunaris Temple Level 1 - Go to Lunaris Temple Level 2",
      "Lunaris Temple Level 2 - Kill Piety - Take Tower Key - TP to Town",
      "Town - Talk to NPCs - WP to Ebony Barracks",
      "Ebony Barracks - Go to Imperial Gardens (right)",
      "Imperial Gardens - Tag WP - Solve Trial - (Don't pick up Plum) - TP to Town, WP back -",
      "Go to Sceptre of God",
      "Sceptre of God - Go to Upper Sceptre of God",
      "Upper Sceptre of God - Go to Tower Rooftop",
      "Tower Rooftop - Kill Dominus - Go to Act IV",
    ],
  },
  {
    id: 4,
    actName: "ACT 4",
    act: [
      "Aqueduct - Go to Town",
      "Town - Go to Dried Lake",
      "Dried Lake - Kill Voll - TP to Town",
      "Town - Go to Mines",
      "Mines Level 1 - Go to Mines Level 2",
      "Mines Level 2 - Tag Deshret's Spirit - Go to Crystal Veins",
      "Crystal Veins - Tag WP - Go to Daresso's Dream",
      "Daresso's Dream - Kill Barkhul - Go to Grand Arena",
      "Grand Arena - Kill Unique Trio - Kill Daresso - TP to Town",
      "Town - Talk to NPCs - WP to Crystal Veins",
      "Crystal Veins - Go to Kaom's Dream",
      "Kaom's Dream - Go to Kaom's Stronghold",
      "Kaom's Stronghold - Kill Kaom - TP to Town",
      "Town - WP to Crystal Veins",
      "Crystal Veins - Talk to Dialla - Go to Belly of the Beast",
      "Belly of the Beast Level 1 - Go to Belly of the Beast Level 2",
      "Belly of the Beast Level 2 - Kill Piety - Go to Harvest",
      "Harvest - Tag WP - Go up - Kill Boss - TP to Town - WP to Harvest - Go down - Kill",
      "Boss - Kill next Boss - TP to Town - WP to Harvest - Go to Black Core",
      "Black Core - Kill Malachai - TP to Town",
      "Town - Talk to NPCs - Go to Ascent",
      "Ascent - Activate Resonator - Go to Act V",
    ],
  },
  {
    id: 5,
    actName: "ACT 5",
    act: [
      "Slave Pens - Kill Overseer Krow - Go to Town",
      "Town - Go to Control Blocks",
      "Control Blocks - Pick up Miasmeter - Kill Justicar Casticus - Go to Oriath Square",
      "Oriath Square - Go to Templar Courts",
      "Templar Courts - Go to Chamber of Innocence",
      "Chamber of Innocence - Go to Sanctum of Innocence",
      "Sanctum of Innocence - Kill High Templar Avarius - Kill Innocence - Go to Chamber of",
      "Innocence",
      "Chamber of Innocence - Go to Torched Courts",
      "Torched Courts - Go to Ruined Square",
      "Ruined Square - Tag WP - Go to Ossuary (near WP)",
      "Ossuary - Pick up Sign of Purity - TP to Town",
      "Town - Talk to NPCs - WP to Ruined Square",
      "Ruined Square - Go to Reliquary (down)",
      "Reliquary - Collect Kitava's Torments (corners of zone) - TP to Town",
      "Town - Talk to NPCs - WP to Ruined Square",
      "Ruined Square - Go to Cathedral Rooftop (left)",
      "Cathedral Rooftop - Go to Cathedral Apex",
      "Cathedral Apex - Kill Kitava - Get teleported to Town",
      "Town - Sail to ACT VI",
    ],
  },
  {
    id: 6,
    actName: "ACT 6",
    act: [
      "Town - Go to Twilight Strand",
      "Twilight Strand - Kill all Monsters (for Book of Regrets reward and all gems from Lilly) -",
      "TP to Town",
      "Town - Talk to NPCs - Go to Coast",
      "Coast - Go to Mudflats",
      "Mudflats - Kill Dishonoured Queen (top/right) - Go to Karui Fortress (top/left)",
      "Karui Fortress - Kill Tukohama (right) - Go to Ridge",
      "Ridge - Go to Lower Prison",
      "Lower Prison - Solve Trial - Go to Shavronne's Tower",
      "Shavronn's Tower - Go to Prison Rooftop",
      "Prison Rooftop - Kill Brutus and Shavronne - Go to Warden's Chambers",
      "Warden's Chambers - Go to Prisoner's Gate",
      "Prisoner's Gate - Tag WP - Go to Valley of the Fire Drinker",
      "Valley of the Fire Drinker - Kill Abberath - TP to Town",
      "Town - Talk to NPCs - WP to Prisoner's Gate",
      "Prisoner's Gate - Go to Western Forest",
      "Western Forest - Go to Riverways (follow road)",
      "Riverways - Tag WP - Go to Wetlands (up)",
      "Wetlands - Go to Spawning Ground",
      "Spawning Ground - Kill Ryslatha - TP to Town",
      "Town - Talk to NPCs - WP to Riverways",
      "Riverways - Go to Southern Forest (follow road, then down)",
      "Southern Forest - Go to Cavern of Anger",
      "Cavern of Anger - Take Black Flag - Go to Beacon",
      "Beacon - Refuel the Beacon - Light the Beacon - Sail to Brine King's Reef",
      "Brine King's Reef - (left hand shore line follow) - Kill Tsoagoth - Sail to Act VII",
    ],
  },
  {
    id: 7,
    actName: "ACT 7",
    act: [
      "Town - Go to Broken Bridge",
      "Broken Bridge - Go to Crossroads (follow road/left)",
      "Crossroads - Tag WP - Go to Fellshrine Ruins (down/right)",
      "Fellshrine Ruins - Go to Crypt",
      "Crypt Level 1 - Solve Trial - Go to Crypt Level 2",
      "Crypt Level 2 - Take Maligaro's Map - TP to Town",
      "Town - WP to Crossroads",
      "Crossroads - Go to Chamber of Sins",
      "Chamber of Sins Level 1 - Find Map Device - Open Maligaro's Map - Go to Maligaro's",
      "Sanctum",
      "Maligaro's Sanctum - Kill Maligaro - TP to Chamber of Sins",
      "Chamber of Sins Level 1 - Take Key from Sin - Go to Chamber of Sins Level 2",
      "(direction of WP)",
      "Chamber of Sins Level 2 - Solve Trial - Go to Den (top/right)",
      "Den - Go to Ashen Fields",
      "Ashen Fields - Go to Fortress Encampment (follow road to the left/down)",
      "Fortress Encampment - Kill Greust - Go to Northern Forest",
      "Northern Forest - Tag WP - Go to Dread Thicket (left hand wall follow)",
      "Dread Thicket - Collect Fireflys - Kill Gruthkul (in her Den) - TP to Town",
      "Town - Talk to NPCs - WP to Northern Forest",
      "Northern Forest - Go to Causeway (right hand wall follow)",
      "Causeway - Take Kishara's Star (At some point go back to Town and talk to Weylam for",
      "skill and regret points) - Go to Vaal City",
    ],
  },
  {
    id: 8,
    actName: "ACT 8",
    act: [
      "Sarn Ramparts - Go to Sarn Encampment",
      "Sarn Encampment - Go to Toxic Conduits",
      "Toxic Conduits - Go to Deodre's Cesspool (direction of black paint sludge at beginning",
      "of the zone)",
      "Deodre's Cesspool - Go to Cauldron - Kill Deodre - Tag WP - Go to Grand Promenade",
      "(down/left from WP)",
      "Grand Promenade - Go to Bath House (right hand fence follow)",
      "Bath House - Tag WP - Kill Hector Titucius - Take Wings - Solve Trial (top or left) - Go",
      "to High Gardens (top or left)(if you want to kill Yugul now)(othewise go to Lunaris",
      "Concourse)",
      "High Gardens - Kill Yugul - TP to Town",
      "Town - Talk to NPCs - WP to Bath House",
      "Bath House - Go to Lunaris Concourse",
      "Lunaris Concourse - Tag WP - Go to Lunaris Temple",
      "Lunaris Temple Level 1 - Go to Lunaris Temple Level 2",
      "Lunaris Temple Level 2 - Kill Dusk - TP to Town",
      "Town - Talk to NPCs - WP to Deodre's Cesspool (WP is called Toxic Conduits for",
      "whatever reason)",
      "Deodre's Cesspool - Go to Quay (up/right from WP)",
      "Quay - Take Ankh (down, near beginning of zone) - Kill Tolman (down/right) - Go to",
      "Grain Gate (up/right)",
      "Grain Gate - Kill Gemling Legion - Go to Imperial Fields",
      "Imperial Fields - Go to Solaris Temple (follow road then further up)",
      "Solaris Temple Level 1 - Go to Solaris Temple Level 2 (up from WP)",
      "Solaris Temple Level 2 - Kill Dawn - TP to Town",
      "Town - Talk to NPCs - WP to Lunaris Concourse",
      "Lunaris Concourse - Go to Harbour Bridge (down/right)",
      "Harbour Bridge - Kill Lunaris and Solaris - Go to ACT IX",
    ],
  },
  {
    id: 9,
    actName: "ACT 9",
    act: [
      "Blood Aqueduct - Go to Highgate (or stay here till lvl 70)",
      "Highgate - Go to Descent",
      "Descent - Go to Vastiri Dessert",
      "Vastiri Dessert - Open Storm-Weathered Chest - Kill Monsters - Pick up Storm Blade -",
      "TP to Town",
      "Town - Talk to NPCs (Get Bottled Storm) - TP to Vastiri Dessert",
      "Vastiri Dessert - Tag WP - Go to Oasis (up/right)",
      "Oasis - Kill Shakari - TP to Town",
      "Town - Talk to NPCs - WP to Vastiri Dessert",
      "Vastiri Dessert - Go to Foothills (up/left)",
      "Foothills - Tag WP - Go to Boiling Lake (right from WP)",
      "Boiling Lake - Kill Basilisk - TP to Town",
      "Town - WP to Foothills",
      "Foothills - Kill Boulderback (for Book of Regrets) - Go to Tunnel (top/left)",
      "Tunnel - Solve Trial (before the WP) - Go to Quarry",
      "Quarry - Tag WP - Go to Shrine of the Winds (left)",
      "Shrine of the Winds - Kill Garukhan - TP to Town",
      "Town - Talk to NPCs - WP to Quarry",
      "Quarry - Go to Refinery (right)",
      "Refinery - Kill General Adus - Take Powder - TP to Town",
      "Town - Talk to NPCs - WP to Quarry",
      "Quarry - Go to Belly of the Beast",
      "Belly of the Beast - Go to Rotting Core",
      "Rotting Core - Go to Black Heart",
      "Black Heart - Kill Shavronne, Maligaro, Deodre - Kill Depraved Trinity - Sail to Act X",
    ],
  },
  {
    id: 10,
    actName: "ACT 10",
    act: [
      "Oriath Docks - Go to Cathedral Rooftop",
      "Cathedral Rooftop - Go to Cathedral Apex and save Bannon (left) - Go to Ravaged",
      "Square (top/right)",
      "Ravaged Square - Tag WP (right/up) - Go to Torched Courts (right)",
      "Torched Courts - Go to Desecrated Chambers",
      "Desecrated Chambers - Kill Avarius - TP to Town",
      "Town - Talk to NPCs - WP to Ravaged Square",
      "Ravaged Square - Go to Control Blocks (down)",
      "Control Blocks - Kill Vilenta (right hand wall follow) - TP to Town",
      "Town - Talk to NPCs - WP to Ravaged Square",
      "Ravaged Square - Go to Ossuary (next to WP)",
      "Ossuary - Solve Trial - Pick up Elixir of Allure (for Book of Regrets) - TP to Town",
      "Town - Talk to NPCs - WP to Ravaged Square",
      "Ravaged Square - Talk to Innocence (top) - Go to Canals",
      "Canals - Go to Feeding Trough (follow canal)",
      "Feeding Trough - Kill Kitava",
    ],
  },
];

export default POE_DATA;
